import { useState, useRef, useCallback, useContext } from "react";
import { EditorButton } from "./buttons";
import { formatButtons } from "./data";
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { AppAlert } from "../utilities/alert";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { BlogPostContext } from "../../services/blogs/blogpost.context";

export const TextInputEditor = () => {

    const { isLoading, createNewBlog } = useContext(BlogPostContext);

    const { token } = useAuthentication();

    const [content, setContent] = useState('');
    const [fileArray, setFileArray] = useState([]);
    const [onAlert, setOnAlert] = useState();
    const [blogTitle, setBlogTitle] = useState('');
    const [videoLink, setVideLink] = useState('');

    const inputRef = useRef();
    const filesRef = useRef();

    // Function to apply formatting to the selected text
    const toggleNativeFormatting = useCallback((command) => {
        // Ensure the contentEditable div is focused to make execCommand work reliably
        if (inputRef.current) {
            inputRef.current.focus();
        }
        // execCommand toggles the format if it's already present in the selection,
        // and applies it if not. It's built for contentEditable.
        document.execCommand(command, false, null);

        // Update state if you're tracking the HTML content
        if (inputRef.current) {
            setContent(inputRef.current.innerHTML);
        }
    }, []);

    const alertCancelImage = (index) => {
        setOnAlert({
            caption: "Remove Image",
            message: "Do you wish to remove this picture from the collection",
            accept: "Remove",
            reject: "Cancel",
            onAccept: () => {
                setFileArray((arr) => (arr.filter((e) => arr.indexOf(e) !== index)));
                setOnAlert();
            },
            onReject: () => setOnAlert()
        })
    }

    return (
        <div className="editor-wrapper">
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAccept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="editor-toolbar">
                {formatButtons.map((btt, indx) => (
                    <EditorButton
                        image={`/svgs/${btt.image}.svg`}
                        key={indx}
                        action={() => toggleNativeFormatting(btt.action)}
                    />
                ))}
                <EditorButton
                    image={`svgs/images.svg`}
                    action={() => filesRef.current.click()}
                />
                <input
                    type="file"
                    ref={filesRef}
                    className="inv-file"
                    onChange={(e) => {
                        if (fileArray.length === 4) {
                            return alert("Image limit reached!");
                        }
                        setFileArray((arr) => ([...arr, e.target.files[0]]))
                    }}
                />
            </div>
            <div className="blog-title-input">
                <input
                    type="text"
                    className="text-input"
                    onChange={(e) => setBlogTitle(e.target.value)}
                />
            </div>
            <div
                className="text-editor"
                contentEditable
                ref={inputRef}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
                onBlur={(e) => {
                    setContent(e.currentTarget.innerHTML);
                }}

            />
            <div className="blog-title-input">
                <span className="input-cap">You tube link</span>
                <input
                    type="url"
                    className="text-input"
                    onChange={(e) => setVideLink(e.target.value)}
                />
            </div>
            {fileArray.length > 0 && (
                <div className="pictures">
                    {fileArray.map((file, i) => (
                        <div key={i} className="picture-frame">
                            <button
                                className={classNames("glass-button", "btn")}
                                onClick={() => alertCancelImage(i)}
                            >
                                <FontAwesomeIcon icon={faClose} />
                            </button>
                            <img
                                src={URL.createObjectURL(file)}
                                className="picture"
                                alt=""
                            />
                        </div>
                    ))}
                </div>
            )}

            <button
                onClick={async () => {
                    if (!content || content === undefined || content === '' || content.length < 150) {
                        setOnAlert({
                            caption: "Error",
                            message: "Content not available or too short",
                            accept: "OK",
                            onAccept: () => setOnAlert(),
                            onClose: () => setOnAlert()
                        });
                        return;
                    }
                    const blogData = { content, files: fileArray, title: blogTitle, youtube: videoLink }
                    //console.log({blogData, token});
                    const resp = await createNewBlog(blogData, token);
                   // console.log(resp);
                    if (resp?.error) {
                        setOnAlert({
                            caption: "Error",
                            message: resp?.error,
                            accept: "OK",
                            onAccept: () => setOnAlert(),
                            onClose: () => setOnAlert()
                        });
                        return;
                    }
                    setOnAlert({
                        caption: "Success",
                        message: resp?.message,
                        accept: "OK",
                        onAccept: () => setOnAlert(),
                        onClose: () => setOnAlert()
                    });

                    window.location.reload();
                }}
                className="submit-blog"
            >
                Submit
            </button>
        </div>
    )
}